var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "pa-0 wizard-uvod" },
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { autocomplete: "off" },
              on: { input: _vm.updateFormValid }
            },
            [
              _vm.debug
                ? _c("debug-control", {
                    attrs: {
                      value: [
                        "validationObjectResult",
                        "formValid",
                        "somethingGetDirty",
                        "somethingIsLoading",
                        "currentControl",
                        "zastupca",
                        "pripad"
                      ],
                      parent: this
                    },
                    on: { click: _vm.log }
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "wizard-content" },
                [
                  _c("uvod-banner", { attrs: { isMobile: _vm.isMobile } }),
                  _c(
                    "v-card",
                    { staticClass: "card-forma-podnikania card" },
                    [
                      _vm.jePrihlaseny
                        ? [
                            _c("h2", { staticClass: "mb-2" }, [
                              _vm._v("Výber profilu")
                            ]),
                            _c("span", { staticClass: "gs100 f16" }, [
                              _vm._v("Ponuku vytvárate k profilu "),
                              _c("span", { staticClass: "white100 f16" }, [
                                _vm._v(_vm._s(_vm.currentProfileName))
                              ])
                            ]),
                            _c("br"),
                            _c("span", { staticClass: "gs100 f16" }, [
                              _vm._v(
                                "Ak si prajete vybrať iný profil, prejdite do menu vpravo hore."
                              )
                            ]),
                            _c("br"),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-secondary mt-6",
                                on: {
                                  click: function($event) {
                                    return _vm.getCreateProfileLink()
                                  }
                                }
                              },
                              [_vm._v(" Vytvoriť nový profil ")]
                            )
                          ]
                        : [
                            _c("h2", { staticClass: "mb-6" }, [
                              _vm._v("Nájomca")
                            ])
                          ],
                      _c("uvod-forma", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jePrihlaseny,
                            expression: "!jePrihlaseny"
                          }
                        ],
                        ref: "formaPodn",
                        attrs: {
                          parentReloaded: _vm.reloaded,
                          disabled: _vm.vytvaranieZakaznikaPrebieha
                        },
                        model: {
                          value: _vm.formaPodn,
                          callback: function($$v) {
                            _vm.formaPodn = $$v
                          },
                          expression: "formaPodn"
                        }
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }